'use strict';

// グラフモード切替のデータレジストリ
window.leagueGraphModes = window.leagueGraphModes || {};

$(document).on('click', '.toggle-switch-btn[data-chart-id] .switch-option', function() {
  var $option = $(this);
  var $toggle = $option.closest('.toggle-switch-btn');
  var mode = $option.data('mode');
  var chartId = $toggle.data('chart-id');

  if ($option.hasClass('active')) return;

  // active切替
  $toggle.find('.switch-option').removeClass('active');
  $option.addClass('active');

  // スライダー位置の切替
  if ($toggle.attr('data-options')) {
    // 3択トグル: 選択位置のindexでスライダーを移動する
    $toggle.attr('data-active-index', $option.index());
  } else {
    var isSecond = $option.index() === 1;
    $toggle.toggleClass('three-active', isSecond);
  }

  // 3択トグルの説明文を選択中モードのものに差し替える（HAMLの data 属性から取得）
  var $hint = $('[data-graph-mode-hint="' + chartId + '"]');
  if ($hint.length) {
    var hintText = $hint.attr('data-hint-' + mode);
    if (hintText !== undefined) $hint.text(hintText);
  }

  // Chart.jsインスタンスとモードデータを取得
  var chart = window[chartId];
  var modeData = window.leagueGraphModes[chartId];
  if (!chart || !modeData || !modeData[mode]) return;

  var data = modeData[mode];

  chart._graphMode = mode;
  chart._matchIndices = data.matchIndices || null;
  chart._tooltipLabels = data.tooltipLabels || null;

  // 凡例の表示状態を保持
  var hiddenStates = [];
  chart.data.datasets.forEach(function(ds, i) {
    hiddenStates.push(chart.getDatasetMeta(i).hidden);
  });

  chart.data.labels = data.labels;
  chart.data.datasets = data.datasets;

  // Y軸の範囲更新（設定されている場合のみ）
  if (data.yMax !== undefined && data.yMin !== undefined) {
    chart.options.scales.y.max = data.yMax;
    chart.options.scales.y.min = data.yMin;
  }

  chart.update();

  // 凡例の非表示状態を復元
  hiddenStates.forEach(function(hidden, i) {
    if (i < chart.data.datasets.length) {
      chart.getDatasetMeta(i).hidden = hidden;
    }
  });

  // 表示中のデータセットだけでY軸を引き直す（対象チャートのみ。フィルタ購読側でも再適用される）
  if (window.JanrecoUtils) {
    window.JanrecoUtils.rescaleLeagueChartY(chart, chartId);
  }
  chart.update();

  // フィルタ側にdatasets差し替え完了を通知する（フィルタ状態の再適用用）
  document.dispatchEvent(new CustomEvent('league:graph-mode-changed', {
    detail: { chartId: chartId, chart: chart, mode: mode }
  }));
});
